import React, { type JSX } from 'react'

import { Activity } from './Activity'

import { SidebarLayout } from 'shared/layouts'

export const ActivityScreen = (): JSX.Element => {
  return (
    <SidebarLayout>
      <Activity />
    </SidebarLayout>
  )
}
